export default __webpack_public_path__ + "static/media/close.89ba5b59.svg";